import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { auth0WebAuth } from 'modules/boot/sso';
import { SocialButtonsPane, SignupPane } from '../';

class SignupForm extends Component {
  state = {
    onClickGithubProvider: () => {},
    onClickGoogleProvider: () => {},
    onClickMicrosoftProvider: () => {},
    onClickDatabaseProvider: () => {}
  };

  componentDidMount() {
    this.clientInitialize();
  }

  clientInitialize() {
    const { dbConnectionName } = this.props;

    this.setState({
      onClickGithubProvider: () => auth0WebAuth.authorize({ connection: 'github' }),
      onClickGoogleProvider: () => auth0WebAuth.authorize({ connection: 'google-oauth2' }),
      onClickMicrosoftProvider: () => auth0WebAuth.authorize({ connection: 'windowslive' }),
      onClickDatabaseProvider: (username, password, onError) => {
        auth0WebAuth.redirect.signupAndLogin(
          {
            email: username,
            password,
            connection: dbConnectionName
          },
          onError
        );
      }
    });
  }

  render() {
    return (
      <div>
        <div className="form-box">
          <form className="sign-up-form">
            <SignupPane onSignup={this.state.onClickDatabaseProvider} />
            <div className="copy-separate">
              <p>or</p>
            </div>
            <SocialButtonsPane
              onClickGithubProvider={this.state.onClickGithubProvider}
              onClickGoogleProvider={this.state.onClickGoogleProvider}
              onClickMicrosoftProvider={this.state.onClickMicrosoftProvider}
            />
          </form>
        </div>
        <div className="form-box-footer">
          <p>
            By signing up, you agree to our&nbsp;
            <a target="_blank" rel="noopener noreferrer" href="/terms">terms of service</a>
            {' '}
            &nbsp;and&nbsp;
            <a target="_blank" rel="noopener noreferrer" href="/privacy">privacy policy</a>
          </p>
        </div>
      </div>
    );
  }
}

SignupForm.propTypes = {
  dbConnectionName: PropTypes.string.isRequired
};

export default SignupForm;



// WEBPACK FOOTER //
// ./src/modules/signupForm/components/SignupForm/SignupForm.js